import WidgetView from '../widget-view'
import _ from 'lodash'
import NotesWidgetConfig from './notes-widget-config'
import NotesView from 'scoreboard/notes/notes-view'
import template from './notes-widget-view.hbs'
import NotesListView from './notes-list-view'
import canCreateNotes from 'scoreboard/notes/can-create-notes'
import layoutManager from 'scoreboard/components/layout-manager'
import conductor from 'scoreboard/components/conductor'
import togglePrefixedClass from 'scoreboard/components/toggle-prefixed-class'

var NotesWidgetView = WidgetView.extend({
	className: 'widget notes',
	resizable: true,
	configClass: NotesWidgetConfig,

	events: _.extend({
		'click button.add-note': '_showAddDialog'
	}, WidgetView.prototype.events),

	// Not including showNoteDescendants, because that changes what notes are returned from the server
	nonFetchProperties: WidgetView.prototype.nonFetchProperties.concat(
		'showControls', 'showModifyDate', 'showReplies', 'displayMode'
	),

	render: function () {
		WidgetView.prototype.render.apply(this, arguments)

		if (this.$('.content').length === 0) {
			this.$el.append(template())
		} else {
			this.notesView && this.notesView.remove()
		}

		var domainObjectModel = this.model.domainObject()
		if (domainObjectModel) {
			const isTilesView = this.model.properties.get('displayMode') ===
				'tiles'

			if (this.model.section() === 'scorecards') {
				// if we're showing scorecard notes, pass any descendants and soure nodes along to the
				// NotesView so it can indicate the descendant/source when appropriate
				var otherNodes = _(domainObjectModel.get('notes'))
					.flatMap('domainId')
					.uniq()
					.map(function (snId) {
						return this.model.data.scorecards(snId)
					}.bind(this))
					.keyBy('id').value()
			}
			// Note that we don't show descendant notes for initiatives

			if (isTilesView) {
				this.notesView = new NotesView({
					model: domainObjectModel,
					showAddButton: this.model.properties.get('showControls'),
					showReplies: this.model.properties.get('showReplies'),
					showModifyDate: this.model.properties.get('showModifyDate'),
					alwaysShowDomainObject: true,
					otherDomainObjects: otherNodes,
					disabled: this.disabled(),
					guard: this.readonly
				})

				this.listenTo(this.notesView, 'change:notes', (count) => {
					this.$('.title-text .note-count').text(count)
				})
			} else {
				this.notesView = new NotesListView({
					model: this.model,
					domainObjectModel,
					otherDomainObjects: otherNodes,
					disabled: this.disabled(),
					guard: this.readonly
				})

				this.listenTo(this.notesView, 'change:count', count => {
					this.$('.title-text .note-count').text(count)
				})
			}

			this.$('.panel-content').append(this.notesView.el)
			this.notesView.render()

			// #21352 set the font size for the notes content.
			togglePrefixedClass(this.el, 'font-size', this.model.properties
				.get('fontSize'))

			this._renderHeader()

			this.listenTo(domainObjectModel, 'change:notes', this._onChangeNotes.bind(this))
		}

		if (!this.readonly) {
			this.$('.button').addClass('is-disabled')
		}

		this.readyForDisplayAndExport()

		return this
	},

	_renderHeader: function () {
		let domainObjectModel = this.model.domainObject()

		let showHeader = false

		let showLabel = this.model.properties.get('showLabel')
		if (showLabel) {
			showHeader = true
		}

		this.$el.toggleClass('has-title', showLabel)
		let isFull = this.model.properties.get('displayMode') === 'full'
		let showAddButton = isFull && this.model.properties.get('showControls') &&
			canCreateNotes(domainObjectModel)
		this.$el.toggleClass('is-display-full', isFull)
		this.$el.toggleClass('is-display-tiles', !isFull)
		if (showAddButton) {
			showHeader = true
		}
		this.$('.note-widget-header .add-note').toggleClass('is-not-displayed', !showAddButton)

		this.$('.note-widget-header').toggleClass('is-not-displayed', !showHeader)

		var notes = domainObjectModel.get('notes')
		this.$('.note-widget-header .note-count').text(notes ? notes.length : 0)
		this.$('.note-widget-header .domain-object-label').text(domainObjectModel.get('label'))
	},

	_onChangeNotes: function () {
		this.notesView.render()
		this._renderHeader()
	},

	_showAddDialog() {
		if (this.notesView) {
			layoutManager.sharedResource ?
				this._newNoteDrilldown() :
				this.notesView.showAddDialog()
		}
	},

	_newNoteDrilldown() {
		const domainId = this.model.domainObject().id
		const url = `${this.model.section()}/${domainId}/note`
		conductor.navigate(url)
	},

	disable(disable) {
		this.notesView && this.notesView.disable && this.notesView.disable(this.disabled())
	},

	isDrilldownExcluded(evtEl) {
		return this.elIsOrIsDescendantOfSelector(
			evtEl, '.panel-content .note-preview, .text-link'
		)
	},

	remove: function() {
		WidgetView.prototype.remove.apply(this, arguments)
		_.invokeMap([this.notesView], 'remove')
	}
})

export default NotesWidgetView

NotesWidgetView.__filename__ = 'dashboards/widgets/notes/notes-widget-view.js'
